import React from 'react';

const DownloadIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-download" />
    </div>
  );
};

export default DownloadIcon;
